import {PerformanceAdvice} from './performance-advice';
import {PerformanceRequest} from './performance-request';

export class PerformanceTest {

  public id: string;
  public score: number;
  public grade: string;
  public testedUrl: string;
  public loadTime: number;
  public pageSize: number;
  public requestsCount: number;
  public testedAt: Date;

  public advices: PerformanceAdvice[];
  public requests: PerformanceRequest[] | null;

}
